import { useRef } from "react";
const useLastValue = (value)=>{
    const valueRef = useRef(value);
    valueRef.current = value;
    return valueRef;
};
export default useLastValue;

//# sourceMappingURL=useLastValue.js.map